import React, { useEffect, useState } from 'react';
import { useSnackbarContext } from '../../../contexts/Snackbar';
import { getPlaidLink } from '../../API';
import ConnectBank from '../../Bank/ConnectBank';
import Loader from '../../Loader';
import messages from '../../../messages';

interface DialogProps {
  goNext: (...args) => void;
  goBack: (...args) => void;
}

export default function ConnectBankStep({ goBack, goNext }: DialogProps) {
  const [plaidLinkToken, setPlaidLinkToken] = useState(null);
  const snackbar = useSnackbarContext();

  async function getPlaidLinkToken() {
    try {
      const plaidToken = await getPlaidLink();
      setPlaidLinkToken(plaidToken.link_token);
      localStorage.setItem('plaidToken', plaidToken.link_token);
    } catch (error) {
      console.log('plaidLinkToken error', error);
      snackbar.show(messages.bank.errors.plaidLinkToken, 'error');
      goBack();
    }
  }
  useEffect(() => {
    getPlaidLinkToken();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <>
      {plaidLinkToken ? (
        <ConnectBank
          openImmidiately={true}
          plaidLinkToken={plaidLinkToken}
          onSuccess={goNext}
          goBack={goBack}
        />
      ) : (
        <Loader />
      )}
    </>
  );
}
